export default {
  props: {
    organization_id: {},
    harvest_process_id: {},
  },
}
